/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { PostUsersAuthRefresh200, PostUsersAuthRefresh400, PostUsersAuthRefreshMutationResponse } from '../entities/PostUsersAuthRefresh'
import type { ToZod } from '@kubb/plugin-zod/utils'
import { errorStructSchema } from './errorStructSchema'
import { userRefreshResponseSchema } from './userRefreshResponseSchema'
import { z } from 'zod'

/**
 * @description OK
 */
export const postUsersAuthRefresh200Schema = z.lazy(() => userRefreshResponseSchema) as unknown as ToZod<PostUsersAuthRefresh200>

/**
 * @description Bad Request
 */
export const postUsersAuthRefresh400Schema = z.lazy(() => errorStructSchema) as unknown as ToZod<PostUsersAuthRefresh400>

export const postUsersAuthRefreshMutationResponseSchema = z.lazy(() => postUsersAuthRefresh200Schema) as unknown as ToZod<PostUsersAuthRefreshMutationResponse>